<button
    class="sectionButton"
    [ngClass]="{ activeSectionButton: active }"
    >
    {{label}}
    <img
        *ngIf="invalid"
        [title]="invalidFormMessage"
        src="assets/statusIncomplete.svg"
        class="invalid-fields-warning"
    />
</button>